import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import echarts from "echarts";
import "./assets/font/iconfont.css";
import "./assets/css/jlobal.less";
import "assets/theme/vintage";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import "./mock/index";
import { formatWithMod } from "@/utils/utils";
import '@/icons'; // icon

//导出组件 文件路径为你创建js文件的路径
import outToExcel from "@/utils/exportExcelUtils";
// 全局方法挂载 outToExcel(随意名称) = outToExcel(引入的名称);
Vue.prototype.outToExcel = outToExcel;
// 全局组件挂载 (随意名称,挂载的名称)
Vue.component('outToExcel', outToExcel)
Vue.use(outToExcel)

// import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
Vue.prototype.$echarts = echarts;
Vue.prototype.formatWithMod = formatWithMod;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
